import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  Platform,
  Animated,
  TouchableOpacity,
  Linking,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  button,
  Typo,
  siteFooter,
  FontFamily,
} from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";
import TouchableOpacityLinkExternal from "../touchable-opacity-link-external";
import apiHelpers from "../../utils/api-helpers";
import { helpers } from "../../utils/helpers";
import getImagePath from "../../utils/image-helper";
import CustomImage from "../custom-image";
import ContentLoader from "react-native-easy-content-loader";
import EmailLink from "../email-link";
import { Mixpanel } from "../../utils/mixpanel";
import { Link } from "react-router-dom";
import AuthenticationWrapper from "../authentication-wrapper";

const footerFB = getImagePath("icons/footerFB.png");
const footerTwitter = getImagePath("icons/footerTwitter.png");
const footerIn = getImagePath("icons/footerIn.png");
const footerInsta = getImagePath("icons/instagram.png");
const footerYoutube = getImagePath("icons/youtube.png");
const footerTelegram = getImagePath("icons/footerTelegram.png");
const footerWhatsApp = getImagePath("icons/whatsapp-icon-white.svg");
const footerLogo = getImagePath("icons/footer-logo-icon.svg");
const homeIcon = getImagePath("icons/homeIcon.png");

const greyQuoteLeft = getImagePath("icons/greyQuoteLeft.png");
const greyQuoteRight = getImagePath("icons/greyQuoteRight.png");

const footerLogoLight = getImagePath("icons/tmc-footer-logo.png");

import FooterAccordian from "../../components/footer-accordian";
const YesterdayLogoWjote = getImagePath("img/YesterdayLogoWjote.png");
import ButtonGradient from "../../components/button-gradient";
import FooterMain from "./footer-main";
const yesterdayBadge = getImagePath("img/yesterdayBadge.png");

let mail = "";

export class AppFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: this.props.footerData ? this.props.footerData.menu : false,
      copyright: this.props.footerData
        ? this.props.footerData.copyright
        : false,
      loadSSR: this.props.footerData ? true : false,
      current_path: window.location.href.split("/"),
      custom_user_id: false,
      token: this.props.token,
      userProfile: this.props.userProfile,
      chargebee_billing_platform: this.props.chargebee_billing_platform,
      locationInfo: this.props.locationInfo,
    };
  }

  componentDidMount = () => {
    console.log(this.props.freeUser, "free user status in footer page");
    if (!this.state.loadSSR) {
      this.getFooter();
    }
    if (!this.state.custom_user_id) {
      this.setAuthToken();
    }
  };

  componentDidUpdate = (prevProps) => {
    const propStateUpdates = {};

    if (prevProps.token !== this.props.token) {
      propStateUpdates.token = this.props.token;
    }

    if (prevProps.userProfile !== this.props.userProfile) {
      propStateUpdates.userProfile = this.props.userProfile;
    }

    if (
      prevProps.chargebee_billing_platform !==
      this.props.chargebee_billing_platform
    ) {
      propStateUpdates.chargebee_billing_platform =
        this.props.chargebee_billing_platform;
    }

    if (prevProps.locationInfo !== this.props.locationInfo) {
      propStateUpdates.locationInfo = this.props.locationInfo;
    }

    if (Object.keys(propStateUpdates).length) {
      this.setState(propStateUpdates);
    }
  };

  getFooter = () => {
    let endpoint = `/footer-menu`;
    apiHelpers
      .apiRequest(endpoint, {}, "GET", true)
      .then((res) => {
        if (res.success && res.code == "footer_menu") {
          this.setState({
            menu: res.data.menu,
            copyright: res.data.copyright,
            current_path: window.location.href.split("/"),
          });
          // this.state.menu.append([{name:"TMC Subscriber App"}])
          // console.log("menu items",this.state.menu)
        } else {
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  footerLoader = () => {
    return (
      <View
        style={[
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWebFull,
        ]}
      >
        <ContentLoader
          containerStyles={{ marginBottom: 15 }}
          active={true}
          pHeight={[20]}
          title={false}
          pRows={1}
          pWidth={[140]}
          animationDuration={400}
        />
        <ContentLoader
          containerStyles={{ marginBottom: 5 }}
          active={true}
          pHeight={[10]}
          title={false}
          pRows={1}
          pWidth={[120]}
          animationDuration={400}
        />
        <ContentLoader
          containerStyles={{ marginBottom: 5 }}
          active={true}
          pHeight={[10]}
          title={false}
          pRows={1}
          pWidth={[120]}
          animationDuration={400}
        />
        <ContentLoader
          containerStyles={{ marginBottom: 5 }}
          active={true}
          pHeight={[10]}
          title={false}
          pRows={1}
          pWidth={[120]}
          animationDuration={400}
        />
        <ContentLoader
          containerStyles={{ marginBottom: 5 }}
          active={true}
          pHeight={[10]}
          title={false}
          pRows={1}
          pWidth={[120]}
          animationDuration={400}
        />
      </View>
    );
  };

  pushBottomNavigationEventToDataLayer = (item, sectionName) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "bottom_navigation_click",
      custom_user_id: this.state.custom_user_id || "NA",
      user_status: this.state.custom_user_id ? "logged in" : "guest",
      element_title: item.name.toLowerCase(),
      header_title: sectionName.toLowerCase(),
    });
  };

  pushSocialMediaEventToDataLayer = (socialMediaName) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "social_media_click",
      custom_user_id: this.state.custom_user_id || "NA",
      user_status: this.state.custom_user_id ? "logged in" : "guest",
      element_title: socialMediaName.toLowerCase(),
      header_title: "follow us on",
      scrollDepth: helpers.getScrollDepth(),
    });
  };

  setAuthToken = () => {
    this.props.auth?.getIdTokenClaims().then((tokenClaims) => {
      if (tokenClaims == undefined) {
        this.setState({
          custom_user_id: false,
        });
      } else {
        this.setState({
          custom_user_id: tokenClaims?.legacy_claims?.id,
        });
      }
    });
  };

  trackCateoryClick = (item, sectionName) => {
    try {
      this.pushBottomNavigationEventToDataLayer(item, sectionName);
      if (item.link.includes("/category")) {
        Mixpanel.track("category", {
          category_slug: item.link,
          source_section_type: "footer",
        });
      }
    } catch (error) {
      console.log("mix panel error =>", error);
    }
  };

  returnItemName = (itemName, index) => {
    const itemColors = {
      Internet: "#FC876D",
      Business: "#2CB680",
      Chaos: "#907CFF",
      Opinion: "#ECB731",
      "All Stories": "#FFFFFF",
      Yesterday: "#907CFF",
      "State of the Unicorns": "#BD25BE",
    };
    let selectedColor = itemColors[itemName] || "#FFFFFF";
    return (
      <View style={{ marginBottom: 8 }}>
        <Text
          style={[
            siteFooter.menuListItem,
            { color: selectedColor },
            helpers.isDesktop() && siteFooter.menuListItemDesktop,
          ]}
        >
          {itemName.toUpperCase()}
        </Text>
      </View>
    );
  };

  /**
   * Prevent click event to navigate on click of Email
   * @param {*} e : Event
   */
  stopNavigation = (e) => {
    e.preventDefault();
  };

  render() {
    const {
      menu,
      copyright,
      current_path,
      token,
      userProfile,
      chargebee_billing_platform,
      locationInfo,
    } = this.state;
    const webView = helpers.isWeb();
    let btnClickFB,
      btnClickTwitter,
      btnClickLinkdin,
      btnClickTerms,
      btnClickPrivacy,
      btnClickFaq,
      btnClickYoutube,
      btnClickTelegram,
      btnClickWhatsApp,
      btnClickInsta;
    // let btnClickFB, btnClickTwitter, btnClickLinkdin, btnClickTerms, btnClickPrivacy, btnClickFaq;
    let { Breadcrumbs } = this.props;
    // // let footerData = this.state.menu
    // // footerData.append([{name:"TMC Subscriber App"}])
    // let newItem = [{name:"TMC Subscriber App"}]
    // this.setState({menu:[...menu,newItem]})
    if (webView) {
      btnClickFB = {
        href: "https://www.facebook.com/Morningcontext/",
        handleClick: () => this.pushSocialMediaEventToDataLayer("Facebook"),
      };
      btnClickTwitter = {
        href: "https://twitter.com/MorningContext",
        handleClick: () => this.pushSocialMediaEventToDataLayer("Twitter"),
      };
      btnClickLinkdin = {
        href: "https://www.linkedin.com/company/the-morning-context",
        handleClick: () => this.pushSocialMediaEventToDataLayer("LinkedIn"),
      };
      btnClickYoutube = {
        href: "https://www.youtube.com/channel/UCYAZQvp_LMnL_IAVB8L-rOQ",
        handleClick: () => this.pushSocialMediaEventToDataLayer("Youtube"),
      };
      btnClickTelegram = {
        href: "https://t.me/+hicP5Chbr0MxYTI1",
        handleClick: () => this.pushSocialMediaEventToDataLayer("Telegram"),
      };
      btnClickWhatsApp = {
        href: "https://www.whatsapp.com/channel/0029VaBON51InlqTO0if5g1f",
        handleClick: () => this.pushSocialMediaEventToDataLayer("WhatsApp"),
      };
      btnClickInsta = {
        href: "https://www.instagram.com/themorningcontext/",
        handleClick: () => this.pushSocialMediaEventToDataLayer("Instagram"),
      };
      btnClickTerms = {
        to: "/terms-and-conditions",
      };
      btnClickPrivacy = {
        to: "/privacy-policy",
      };
      btnClickFaq = {
        to: "/faq",
      };
    } else {
      btnClickFB = {
        onPress: () => navigateApp("/"),
      };
      btnClickTwitter = {
        onPress: () => navigateApp("/"),
      };
      btnClickLinkdin = {
        onPress: () => navigateApp("/"),
      };
      btnClickInsta = {
        onPress: () => navigateApp("/"),
      };
      btnClickYoutube = {
        onPress: () => navigateApp("/"),
      };
      btnClickTelegram = {
        onPress: () => navigateApp("/"),
      };
      btnClickWhatsApp = {
        onPress: () => navigateApp("/"),
      };
      btnClickTerms = {
        onPress: () => navigateApp("/"),
      };
      btnClickPrivacy = {
        onPress: () => navigateApp("/"),
      };
      btnClickFaq = {
        onPress: () => navigateApp("/"),
      };
    }

    return (
      <FooterMain
        token={token}
        userProfile={userProfile}
        chargebee_billing_platform={chargebee_billing_platform}
        locationInfo={locationInfo}
      />
    );
  }
}

export default AuthenticationWrapper(AppFooter);
